(() => {
  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'summary',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  const focus = {
    getFocusable(container) {
      if (!container) return [];
      return [...container.querySelectorAll(focusableSelector)].filter(element => element.offsetParent !== null);
    },

    first(container) {
      const element = this.getFocusable(container)[0];
      element?.focus({ preventScroll: true });
      return element;
    },

    trapTab(event, container) {
      if (event.key !== 'Tab') return false;
      const elements = this.getFocusable(container);
      if (!elements.length) return false;
      const first = elements[0];
      const last = elements.at(-1);
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
        return true;
      }
      if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
        return true;
      }
      return false;
    },

    restore(element) {
      element?.focus({ preventScroll: true });
    }
  };

  const motion = {
    query: matchMedia('(prefers-reduced-motion: reduce)'),

    get reduced() {
      return this.query.matches;
    },

    play(element, keyframes, options) {
      if (!element || this.reduced) return null;
      return element.animate(keyframes, { fill: 'both', ...options });
    }
  };

  window.ThemeComponents = Object.freeze({ focus, motion });
})();
